/**
 * Async storage adapter backed by chrome.storage.local.
 *
 * Supabase's GoTrue client accepts a custom storage object; this lets the
 * extension persist the auth session in chrome.storage.local instead of
 * window.localStorage (which is unreliable / sandboxed differently inside the
 * MV3 side-panel page).
 *
 * SECURITY: we use chrome.storage.LOCAL only — NEVER chrome.storage.sync, which
 * would replicate the session (a secret) to the user's Google cloud profile.
 */

/** Minimal async key/value contract shared by both shells (see platform.ts). */
export interface AsyncStorageAdapter {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
}

export const chromeStorageAdapter: AsyncStorageAdapter = {
  getItem(key: string): Promise<string | null> {
    return new Promise((resolve) => {
      chrome.storage.local.get([key], (result) => {
        const value = result?.[key];
        resolve(typeof value === "string" ? value : null);
      });
    });
  },

  setItem(key: string, value: string): Promise<void> {
    return new Promise((resolve) => {
      chrome.storage.local.set({ [key]: value }, () => resolve());
    });
  },

  removeItem(key: string): Promise<void> {
    return new Promise((resolve) => {
      chrome.storage.local.remove([key], () => resolve());
    });
  },
};
